import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const services = [
  {
    tag: 'Core Offering',
    title: 'Outbound Sales Systems',
    desc: 'We build your entire outbound engine from scratch. Ideal customer profile, messaging frameworks, multi-channel sequences, and the tech stack to run it all — so you generate consistent, qualified meetings every month.',
    deliverables: [
      'ICP Research & Segmentation',
      'Cold Email Infrastructure (domain setup, warmup, deliverability)',
      'LinkedIn Outreach Strategy & Execution',
      'Multi-step Messaging Sequences',
      'A/B Testing & Optimization',
      'Monthly Reporting'
    ]
  },
  {
    tag: 'AI & Automation',
    title: 'AI Automation Workflows',
    desc: 'We identify where your team is losing time to repetitive tasks and automate it — lead enrichment, CRM updates, follow-ups, reporting. AI working for you 24/7 so your team can focus on what closes deals.',
    deliverables: [
      'Lead Enrichment Automation',
      'CRM Auto-population & Hygiene',
      'Automated Follow-up Sequences',
      'AI-Powered Lead Scoring',
      'Custom Reporting Dashboards',
      'Tool Integration (Clay, Apollo, HubSpot, Salesforce)'
    ]
  },
  {
    tag: 'Foundation',
    title: 'Sales Infrastructure Build',
    desc: 'You can\'t scale a broken foundation. We implement and configure your CRM, build your sales playbooks, create KPI dashboards, and design the hiring framework so your team can grow without chaos.',
    deliverables: [
      'CRM Implementation & Configuration',
      'Sales Playbook Development',
      'Pipeline Stage Design',
      'KPI Dashboard Setup',
      'Onboarding Documentation',
      'Sales Hiring Scorecard'
    ]
  },
  {
    tag: 'Revenue Ops',
    title: 'Revenue Operations Consulting',
    desc: 'For scaling companies that need a senior operator to align sales, marketing, and customer success around one revenue number. We audit your entire go-to-market motion and fix what\'s broken.',
    deliverables: [
      'Full GTM Audit',
      'ICP & TAM Analysis',
      'Sales & Marketing Alignment Workshop',
      'Revenue Forecast Modeling',
      'Tech Stack Rationalization',
      'Quarterly Strategy Reviews'
    ]
  }
];

export default function Services() {
  return (
    <div className="page">

      {/* Header */}
      <section style={{ paddingBottom: 64, borderBottom: '1px solid var(--border)' }}>
        <div className="container">
          <div className="red-line" />
          <span className="eyebrow">What We Offer</span>
          <h1 style={{ fontSize: 'clamp(40px, 5vw, 72px)', maxWidth: 700 }}>
            Built to generate pipeline.<br />
            <span className="h1-dim">Not just activity.</span>
          </h1>
          <p className="lead" style={{ marginTop: 24 }}>
            Every engagement is custom-built around your business, your ICP, and your growth targets. We don't sell packages — we engineer outcomes.
          </p>
        </div>
      </section>

      {/* Services */}
      <section>
        <div className="container">
          {services.map((s, i) => (
            <div key={i} style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1.5fr',
              gap: 80,
              padding: '72px 0',
              borderBottom: '1px solid var(--border)',
              alignItems: 'start'
            }}>
              <div>
                <span className="case-tag">{s.tag}</span>
                <h2 style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', marginBottom: 20 }}>{s.title}</h2>
                <p style={{ color: 'var(--gray-mid)', lineHeight: 1.85, fontSize: 15 }}>{s.desc}</p>
                <Link to="/contact" className="btn-red" style={{ marginTop: 32, display: 'inline-flex' }}>
                  Get Started <ArrowRight size={14} />
                </Link>
              </div>
              <div style={{ background: 'var(--black-card)', border: '1px solid var(--border)', padding: '40px' }}>
                <p style={{ fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--gray-mid)', marginBottom: 24 }}>What's Included</p>
                <ul className="service-list">
                  {s.deliverables.map((d, j) => <li key={j}>{d}</li>)}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: 'var(--red)', padding: '80px 0' }}>
        <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 32 }}>
          <div>
            <h2 style={{ color: 'var(--white)', marginBottom: 12 }}>Not sure which service fits?</h2>
            <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 15 }}>Book a 30-minute call and we'll tell you exactly what you need.</p>
          </div>
          <Link to="/contact" className="btn-outline" style={{ borderColor: 'rgba(255,255,255,0.4)', color: 'var(--white)', flexShrink: 0 }}>
            Book a Call <ArrowRight size={14} />
          </Link>
        </div>
      </section>

    </div>
  );
}
